import cl from 'clsx';
import ChevronDown from '@synapex/frontend-shared/icons/chevron-down-24.svg?react';

import classes from './GmtSelect.module.scss';

export type GmtSelectDisabledProps = {
  className?: string;
};
export const GmtSelectDisabled = ({ className }: GmtSelectDisabledProps) => {
  return (
    <button
      disabled
      className={cl(classes.itemOrTrigger, classes.trigger, className)}
    >
      –
      <ChevronDown className={classes.chevron} />
    </button>
  );
};
